import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class ZonasService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
    }
    getZonas() {
        const userid = sessionStorage.getItem('userid');
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken'), User: userid });
        return this.http.get(`${this.configService.API_URL}/zonas/listazonascapacitacion?user=${userid}`, { headers }).toPromise();
    }
}
ZonasService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ZonasService_Factory() { return new ZonasService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: ZonasService, providedIn: "root" });
